// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preloader.available {
  opacity: 0;
}

.preloader {
  background-color: #1b2430;
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0.9;
  z-index: 9999;
}

.preloaderTwo {
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  opacity: 0.9;
  z-index: 9999;
}

.svgLoader {
  animation: spin 0.5s linear infinite;
}

.divLoader {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/preloader/_preloader.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AACF;;AACA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EAEA,YAAA;EACA,aAAA;AACF;;AACA;EACE,oCAAA;AAEF;;AACA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAEF;;AACA;EACE;IACE,uBAAA;EAEF;EACA;IACE,yBAAA;EACF;AACF","sourcesContent":[".preloader.available {\n  opacity: 0;\n}\n\n.preloader {\n  background-color: #1b2430;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  opacity: 0.9;\n  z-index: 9999;\n}\n.preloaderTwo {\n  background-color: #ffffff;\n  width: 100%;\n  height: 100%;\n  //position: absolute;\n  opacity: 0.9;\n  z-index: 9999;\n}\n.svgLoader {\n  animation: spin 0.5s linear infinite;\n}\n\n.divLoader {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: auto;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
